export { default } from "graphql-tag";
export * from "graphql-tag";
